export const DEFAULT_SENTRY_DSN =
  "https://574d1cc1d2098436c043488fbc233f5f@o4510866605277184.ingest.us.sentry.io/4511551518998528";
